import { FC } from 'react'

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { COMPETITIONS, CompetitionsSelectType } from '@/components/forms/LicenseForm/constants'

const { SELECT_ALL: ALL, COVER_SELECTED: COVERED } = COMPETITIONS

interface LicenseCompetitionsRadioGroupProps {
  value: CompetitionsSelectType
  onChange: (value: CompetitionsSelectType) => void
  disabled?: boolean
}

export const COMPETITIONS_SELECT_TYPE_OPTIONS = [
  { label: ALL, value: ALL },
  {
    label: COVERED,
    value: COVERED
  }
  // TODO: uncomment when BE part will be ready
  // { label: EXCLUDED, value: EXCLUDED }
] as const

export const LicenseCompetitionsRadioGroup: FC<LicenseCompetitionsRadioGroupProps> = ({
  value,
  onChange,
  disabled
}) => {
  return (
    <FormControl>
      <RadioGroup
        name="my-radio-group"
        value={value}
        onChange={(e) => onChange(e.target.value as CompetitionsSelectType)}
        sx={{
          '& .MuiFormControlLabel-label': {}
        }}
      >
        {COMPETITIONS_SELECT_TYPE_OPTIONS.map((option) => (
          <FormControlLabel
            disabled={disabled}
            key={option.value}
            value={option.value}
            control={<Radio size="small" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
